import { render } from "./ChoiceModal.vue?vue&type=template&id=28affe82&bindings={\"content_data\":\"props\",\"last_value\":\"props\",\"select_name\":\"props\",\"modal_title\":\"props\",\"close_modal\":\"props\",\"save_function\":\"props\",\"additional_field\":\"props\",\"additional_field_label\":\"props\",\"language\":\"setup\",\"lang\":\"data\",\"checkForAdditionalHeight\":\"options\"}"
import script from "./ChoiceModal.vue?vue&type=script&lang=js"
export * from "./ChoiceModal.vue?vue&type=script&lang=js"

import "./ChoiceModal.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script